import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { DateRangeInterval } from '../../../core/components/date-range/date-range.component';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';

@Component({
  selector: 'tt-vat-spesification',
  templateUrl: './vat-spesification.component.html',
  styleUrls: ['./vat-spesification.component.css']
})
export class VatSpesificationComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public grid?: GridOptions;

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3431))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_vatspesification_grid').setLoadDataFunction({ method: 3432, parameters: () => this.setting }).setKendoConfig({ height: '100%' }).setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    public onDateRangeChanged() {
        this.loadGrid();
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    businessco_no: string;
    show_setting: string;
    date_fomtom: string;
}
